export default __webpack_public_path__ + "static/media/bg.95229950.jpg";